import { render, staticRenderFns } from "./BrandAuthApplyLogs.vue?vue&type=template&id=712a3792"
import script from "./BrandAuthApplyLogs.vue?vue&type=script&lang=ts"
export * from "./BrandAuthApplyLogs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports